import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Binding from "../../../binding";
import MaintReq from "../Maint/MaintReq";
import PriorityIcon from "../../Misc/PriorityIcon";
import PriorityButton from "../../Misc/PriorityButton";

export default class ElementMaint extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      pending: false,

      reqModalShow: false,
      reqItem: {},
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  load = async () => {
    this.setState({ pending: true });
    let items = await this.context.api.qa("/maintenance/item/list", {
      filter: { elementid: this.props.elementId },
    });
    this.setState({
      pending: false,
      items,
    });
  };

  onRemove = async (item) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/item/delete", {
      id: item.id
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  onAdd = async (item) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/item/set", {
      document: item.id,
      element: this.props.elementId,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  onElementReqOpen = (item) => {
    this.setState({
      reqItem: item || {},
      reqModalShow: true,
      reqId: item.id,
      reqElementId: item.elementid,
      reqElementName: item.element.modelname,
      reqDocumentId: item.documentid,
      reqDocumentName: item.document.label,
    });
  };

  onElementReqClose = () => {
    this.setState({ reqModalShow: false });
  };

  onAfterElementReqSave = () => {
    this.load();
  };

  render() {
    const { pending, items } = this.state;

    return (
      <>
        <MaintReq
          show={this.state.reqModalShow}
          onClose={this.onElementReqClose}
          onAfterSave={this.onAfterElementReqSave}
          elementId={this.state.reqElementId}
          elementName={this.state.reqElementName}
          itemId={this.state.reqId}
          itemName={this.state.reqDocumentName}
          manageMaint={this.props.manageMaint}
          data={this.state.reqItem}
        />
        <Blocker on={pending}>
          {items.map((item, idx) => {
            let document = item.document || {};
            let binding = new Binding({
              ...document,
              classcode: "maintenance",
            });
            return (
              <div
                key={idx}
                className="my-2 p-3 border d-flex justify-content-between  "
              >
                <Link
                  to={binding.url}
                  className="text-dark-75 text-hover-primary"
                >
                  {item.expired && (
                    <i
                      className="fa fa-clock-o mr-1 text-danger"
                      title="ТО просрочено"
                    ></i>
                  )}

                  {document.label}
                  <div className="small text-muted">
                    <span className="mr-2">
                      {" "}
                      {document.shipname} {document.structurename}
                    </span>
                    {item.meterperiod > 0 && (
                      <span className="mr-2">
                        <i className="fa fa-clock-o mr-1"></i>{" "}
                        {item.meterperiod}
                      </span>
                    )}
                    {item.scheduler && (
                      <span className="mr-2">
                        <i className="fa fa-calendar mr-1"></i>{" "}
                        {item.scheduler.name}
                      </span>
                    )}
                  </div>
                </Link>
                <div className="flex-shrink-0 ml-3">
                  <PriorityButton
                    setPath="/maintenance/item/set"
                    prepareData={({ id }) => {
                      return {
                        priority: id,
                        id: item.id,
                      };
                    }}
                    onAfterChange={this.load}
                    label={document.label}
                    className="btn btn-icon btn-light mr-2"
                    prioritycode={item.priority?.code}
                    priorityIcon={
                      <PriorityIcon
                        showAll
                        prioritycode={item.priority?.code}
                        priorityname={item.priority?.name}
                      />
                    }
                  />
                  <div
                    onClick={() =>
                      this.context.redirect(
                        `/act_maintenance/add/?maint=${item.id}&element=${this.props.elementId}`
                      )
                    }
                    title="Акт выполнения ТО"
                    className="btn btn-icon btn-light mr-2"
                  >
                    <i className="fa fa-check-square-o"></i>
                  </div>
                  <div
                    className="btn btn-icon btn-light"
                    onClick={() => this.onElementReqOpen(item)}
                  >
                    <i className="fa fa-list"></i>
                  </div>
                  {this.props.manageMaint && (
                    <div
                      className="btn btn-icon btn-light ml-2"
                      onClick={() => this.onRemove(item)}
                    >
                      <i className="fa fa-trash"></i>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {this.props.manageMaint && (
            <div className="mt-5 pt-5 border-top">
              <div className="d-flex justify-content-between">
                <div>
                  <div
                    className="btn btn-primary"
                    onClick={() => this.props.onMaintPickOpen(this.onAdd)}
                  >
                    Добавить ТО
                  </div>
                </div>
                <div>
                  <Link
                    to={`/maint/any/${this.props.shipId}`}
                    className="btn btn-light"
                  >
                    Открыть Конструктор ТО <i className="fa fa-wrench ml-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </Blocker>
      </>
    );
  }
}
